import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Alert, Snackbar } from "@mui/material";
import Loader from "../../Loader/Loader";
import { smtpdetail, editsmtp } from "../../service/Mainservice";
import { useFormik } from "formik";

const validate = (values, isInitialLoad) => {
  const errors = {};
  if (isInitialLoad) return errors;

  if (!values.email) {
    errors.email = "Required";
  }
  if (!values.password) {
    errors.password = "Required";
  }

  return errors;
};
const SMTP = () => {
  const [loading, setloading] = useState(true);
  const [load, setload] = useState(false);
  const [data, setData] = useState([]);
  const [showdelete, setshowdelete] = useState(false);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [success, setsuccess] = useState("");
  const [err, seterror] = useState("");
  const [pagination, setpagination] = useState({ page: 1 });

  const navigate = useNavigate();

  useEffect(() => {
    getData("1");
  }, []);

  const getData = async (value) => {
    try {
      const response = await smtpdetail(value);
      setloading(false);
      console.log(response.data.data);
      formik.setValues(
        {
          email: response.data.data.email,
          password: response.data.data.password,
        },
        false
      );
    } catch (error) {
      setloading(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validate,
    onSubmit: (values) => {
      handleAdd(values);
    },
  });

  const handleAdd = async (values) => {
    setload(true);
    try {
      const params = {
        smtp_user: values.email,
        smtp_pass: values.password,
      };
      const response = await editsmtp(params);
      setsuccess(response.data.message);
      setOpen2(true);
      setload(false);
    } catch (error) {
      seterror(error.message);
      setOpen(true);
      setload(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">Mail Server Settings</h1>
        </div>
        <form onSubmit={formik.handleSubmit} className="interview_form">
          <div>
            <label className="Auth_label">Email</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="email"
              type="email"
              minLength={1}
              maxLength={200}
              value={formik.values.email}
              className="Auth_input"
            />
            {formik.errors.email ? (
              <p className="invalid">{formik.errors.email} </p>
            ) : null}
          </div>
          <div>
            <label className="Auth_label">Password</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="password"
              type="text"
              minLength={1}
              maxLength={200}
              value={formik.values.password}
              className="Auth_input"
            />
            {formik.errors.password ? (
              <p className="invalid">{formik.errors.password} </p>
            ) : null}
          </div>

          <div />

          <button className="term_button" type="Submit">
            {load ? "Updating..." : "Save"}
          </button>
        </form>{" "}
      </div>

      {loading && <Loader />}
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
      >
        <Alert severity="error" variant="filled" sx={{ width: "70vw" }}>
          {err}
        </Alert>
      </Snackbar>
      <Snackbar
        open={open2}
        autoHideDuration={6000}
        onClose={() => setOpen2(false)}
      >
        <Alert severity="success" variant="filled" sx={{ width: "70vw" }}>
          {success}
        </Alert>
      </Snackbar>
    </>
  );
};
export default SMTP;
